import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-movetrack",
  "use": "icon-movetrack-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-movetrack\">\n<path d=\"M6.4 0H1.68C0.8 0 0 0.680851 0 1.61702V7.65957C0 8.34043 0.24 8.93617 0.72 9.3617L0.88 9.53191L2.88 11.4894C3.2 11.8298 3.6 12 4 12C4.4 12 4.8 11.8298 5.12 11.4894L7.12 9.44681L7.28 9.2766C7.68 8.85106 8 8.17021 8 7.57447V1.61702C8 0.680851 7.28 0 6.4 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol